class CircleChartController {
  constructor($element) {
    this.$element = $element;

    this.activate();
  }

  $onChanges(percentObj) {
    this.activate();
  }

  activate() {
    let clamp = function (n, min, max) {
      return Math.max(min, Math.min(max, n));
    };

    let drawProgress = (percent) => {

      if(isNaN(percent)) {
        return;
      }

      percent = clamp(parseFloat(percent), 0, 1);

      // 360 loops back to 0, so keep it within 0 to < 360
      let angle = clamp(percent * 360, 0, 359.99999);
      let paddedRadius = 45 + 1;
      let radians = (angle * Math.PI / 180);
      let x = Math.sin(radians) * paddedRadius;
      let y = Math.cos(radians) * - paddedRadius;
      let mid = (angle > 180) ? 1 : 0;
      let pathData = 'M 0 0 v -%@ A %@ %@ 1 '.replace(/%@/gi, paddedRadius)
          + mid + ' 1 '
          + x + ' '
          + y + ' z';

      let bar = this.$element[0].getElementsByClassName('progress-radial-bar')[0];
      // rewrite
      bar.setAttribute( 'd', pathData );
    };

    let max = this.percent / 100;
    let progress = 0.0;

    if (max) {
      drawProgress(progress);

      let interval = window.setInterval(function () {
        progress = progress + 0.01;
        if(progress >= max) {
          window.clearInterval(interval);
        }
        drawProgress(progress);
      }, 10);
    }

  }
}

CircleChartController.$inject = ['$element'];
export default CircleChartController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/components/circle-chart/circle-chart.controller.js